"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleAutomaticSubscription = void 0;
var _constants = require("../constants");
var _types = require("../types");
const handleAutomaticSubscription = (notifications, handleFeedbackOpen)=>{
    const subscriptionNotification = notifications.find((param)=>{
        let { id, notificationAppearance } = param;
        return id === _constants.AUTOMATIC_SUBSCRIPTION_NOTIFICATION_ID && notificationAppearance === _constants.SUBSCRIPTION_NOTIFICATION_APPEARANCE;
    });
    if (subscriptionNotification) {
        handleFeedbackOpen(_types.FeedbackNotificationType.Subscription);
    }
};
exports.handleAutomaticSubscription = handleAutomaticSubscription;
